<template>
  <el-footer>
    <p>{{ configureInfos.content }}</p>
  </el-footer>
</template>

<script>
export default {
  data() {
    return {
      content: ""
    }
  },
};
</script>

<style scoped>
.el-footer {
  height: 44PX !important;
  line-height: 44PX;
  background-color: #B3C0D1;
  position: relative;
  z-index: 1000;
  font-size: 12PX;
}
</style>



// WEBPACK FOOTER //
// src/components/comFooter.vue